import { combineReducers } from "redux";
import accounts from "./accounts/reducer";
import altAssets from "./alt-assets/reducer";
import appSettings from "./app-settings/reducer";
import assetAuditors from "./asset-auditors/reducer";
import assetFoundElsewhere from "./asset-found-elsewhere/reducer";
import assets from "./assets/reducer";
import assetLookup from "./asset-lookup/reducer";
import assignmentDetails from "./assignment-details/reducer";
import auditArchive from "./audit-archive/reducer";
import auditAssets from "./audit-assets/reducer";
import auditAssignments from "./audit-assignments/reducer";
import auditControllers from "./audit-controllers/reducer";
import auditFilters from "./audit-filters/reducer";
import auditGroups from "./audit-groups/reducer";
import auditImages from "./audit-images/reducer";
import auditLocations from "./audit-locations/reducer";
import auditResendAssignmentEmail from "./audit-resend-assignment-email/reducer";
import auditRating from "./audit-rating/reducer";
import auditReview from "./audit-review/reducer";
import audits from "./audits/reducer";
import auditsList from "./audits-list/reducer";
import auditsCreate from "./audits-create/reducer";
import auth from "./auth/reducer";
import branches from "./branches/reducer";
import branchLocations from "./branch-locations/reducer";
import dashboard from "./dashboard-store/reducer";
import dataCheck from "./data-check/reducer";
import dealerContacts from "./dealer-contacts/reducer";
import financeTypes from "./finance-types/reducer";
import http from "./http/reducer";
import locations from "./locations/reducer";
import organisations from "./organisations/reducer";
import skipTrace from "./skip-trace/reducer";
import toast from "./toast/reducer";
import typesList from "./types-list/reducer";
import userLocations from "./user-locations/reducer";
import userOrganisations from "./user-organisations/reducer";
import validationErrors from "./validation-errors/reducer";
import validatedVisibility from "./validated-visibility-assets/reducer";
import auditComment from "./audit-comment/reducer";
import vinDecoder from "./vin-decoder/reducer";

/**
 * Root Reducer
 */
export default combineReducers({
    accounts,
    altAssets,
    appSettings,
    assetAuditors,
    assetFoundElsewhere,
    assets,
    assetLookup,
    assignmentDetails,
    auditArchive,
    auditAssets,
    auditAssignments,
    auditControllers,
    auditFilters,
    auditsList,
    auditGroups,
    auditImages,
    auditLocations,
    auditResendAssignmentEmail,
    auditRating,
    auditReview,
    audits,
    auditsCreate,
    auditComment,
    auth,
    branches,
    branchLocations,
    dashboard,
    dataCheck,
    dealerContacts,
    financeTypes,
    http,
    locations,
    organisations,
    skipTrace,
    toast,
    typesList,
    userLocations,
    userOrganisations,
    validationErrors,
    validatedVisibility,
    vinDecoder
});
